import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { AlertComponent } from './components/alert/alert.component';
import { HeaderComponent } from './components/header/header.component';
import { NavegacionService } from './services/navegacion.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AlertComponent, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'ffsj-new-censo-front';

  private rutaAnterior = '';

  // Instanciar aquí el servicio garantiza que la pila de navegación (botón «Volver») registra desde la primera página.
  constructor(_navegacion: NavegacionService, router: Router) {
    // Accesibilidad: al cambiar de pantalla (no al cambiar solo la búsqueda o los filtros de la URL) el foco pasa al contenido.
    router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(evento => {
      const ruta = evento.urlAfterRedirects.split(/[?#]/)[0];
      const cambioDePantalla = this.rutaAnterior !== '' && ruta !== this.rutaAnterior;
      this.rutaAnterior = ruta;
      if (cambioDePantalla && typeof document !== 'undefined') {
        document.getElementById('contenido')?.focus({ preventScroll: true });
      }
    });
  }
}
